import { Box, Button, Divider, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import DataGrid from '../../components/DataGrid';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import VerticalAlignBottomOutlinedIcon from '@mui/icons-material/VerticalAlignBottomOutlined';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DateTime } from 'luxon';

const Import = (props) => {
  const { closeModal } = props;
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const customer = useSelector((state) => state.customer.customer);
  const navigate = useNavigate();

  const { data, error, isError, isLoading } = useQuery({
    queryKey: ['quotes', customer.id, paginationModel.page],
    queryFn: async () => {
      const params = {
        page: Boolean(paginationModel.page) ? paginationModel.page + 1 : 1,
        customer__id: customer.id,
      };

      const response = await axios.get('/quotes/', { params });
      setRowCount(response.data.count);
      return response.data;
    },
  });

  const quotes = useMemo(() => (data ? data.results : []), [data]);

  useEffect(() => {
    setRowCount((prev) => (data?.count !== undefined ? data?.count : prev));
  }, [data?.count, setRowCount]);

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'Id',
        sortable: false,
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        minWidth: 100,
      },
      {
        field: 'customer',
        headerName: 'Customer',
        sortable: false,
        headerAlign: 'center',
        align: 'left',
        flex: 1,
        minWidth: 200,
        renderCell: (params) =>
          params.row.customer?.first_name +
          ' ' +
          params.row.customer?.last_name,
      },
      {
        field: 'quantity',
        headerName: 'Quantità',
        sortable: false,
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        minWidth: 200,
      },
      {
        field: 'date',
        headerName: 'Date',
        sortable: false,
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        minWidth: 200,
        renderCell: (params) =>
          params.row.date
            ? DateTime.fromISO(params.row.date).toFormat('dd/MM/yyyy HH:mm')
            : null,
      },
      {
        field: 'total',
        headerName: 'TOTAL',
        sortable: false,
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        minWidth: 150,
      },
      {
        field: 'actions',
        headerName: 'ACTION',
        sortable: false,
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        minWidth: 150,
        renderCell: (params) => [
          <Button
            onClick={() => {
              closeModal();
              navigate(`/dashboard/quote/edit/${params.id}`);
            }}
            variant="outlined"
            startIcon={
              <VerticalAlignBottomOutlinedIcon
                fontSize="small"
                sx={{ color: 'primary.main' }}
              />
            }
          >
            Import
          </Button>,
        ],
      },
    ],
    [closeModal, navigate]
  );

  if (isError) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Typography variant="h5" sx={{ color: 'error.main' }}>
          {error.message}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          p: 2,
          maxWidth: '1200px',
          width: '100%',
          bgcolor: 'background.default',
          borderRadius: '5px',
          maxHeight: '85vh',
          overflowY: 'auto',
        }}
      >
        <Typography variant="h5">Lista Preventivi</Typography>
        <Divider variant="fullWidth" sx={{ my: 2 }} />

        <DataGrid
          rows={quotes}
          columns={columns}
          autoHeight
          rowSelection={false}
          disableSelectionOnClick
          loading={isLoading}
          rowCount={rowCount}
          checkboxSelection={false}
          pageSizeOptions={[40]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          sx={{ width: '100%' }}
        />
      </Box>
    </>
  );
};

export default Import;
